import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';

import { Controller } from 'react-hook-form';
import withStyles from 'react-jss';
import { useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';

const AntSelect = GetField(Select);
const AntInput = GetField(Input);

const { Option } = Select;

const FabricForm = props => {
  const {
    productIndex,
    styleIndex,
    classes,
    getValues,
    setValue,
    control,
    fabricItem,
    fabricIndex,
    fabricsAppend,
    fabricsRemove,
    FabricsForSample,
    watch,
  } = props;

  const [widths, setWidths] = useState([]);

  const colorIds = useSelector(state => state.colorIds);
  const fabricStocks = useSelector(state => state.fabricStocks);

  const updateRow = useCallback(
    ({ Consumption, AdditionalPercentage, Stock } = {}) => {
      const fabric =
        getValues(
          `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}]`
        ) || {};

      const styleQuantity =
        +getValues(
          `products[${productIndex}].styles[${styleIndex}].totalQuantity`
        ) || 1;

      const consumption =
        Consumption === undefined ? +fabric.consumption || 0 : +Consumption;

      const additionalPercentage =
        AdditionalPercentage === undefined
          ? +fabric.additionalPercentage || 0
          : +AdditionalPercentage;

      const stock = Stock === undefined ? +fabric.stock || 0 : +Stock;

      if (Stock !== undefined) {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].stock`,
          +stock || 0
        );
      }

      const quantity = +consumption * +styleQuantity;

      const totalQuantity = (
        (+quantity || 0) *
        (1 + (+additionalPercentage || 0) / 100)
      ).toFixed(2);

      setValue(
        `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].quantity`,
        quantity
      );
      setValue(
        `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].totalQuantity`,
        totalQuantity
      );

      if (+stock >= +totalQuantity) {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].toOrder`,
          0
        );
      } else {
        setValue(
          `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].toOrder`,
          +(+totalQuantity - +stock).toFixed(2)
        );
      }
    }
  );

  useEffect(() => {
    if (FabricsForSample.fabricNames.length) {
      const fabricName = getValues(
        `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabric`
      );

      if (FabricsForSample.fabricIndexes[fabricName] !== undefined) {
        setWidths(FabricsForSample.widths[fabricName]);
      } else {
        setWidths([]);
      }
    }
  }, [
    FabricsForSample,
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabric`
    ),
  ]);

  useEffect(() => {
    const productId = getValues(`products[${productIndex}].productId`);

    const fabricId = getValues(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabricId`
    );

    const baseColorId = getValues(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].baseColorId`
    );

    const printColorId =
      getValues(
        `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].printColorId`
      ) || '';

    const stockObject =
      fabricStocks[`P${productId}F${fabricId}B${baseColorId}P${printColorId}`];

    updateRow({ Stock: stockObject ? stockObject.stock : 0 });
  }, [
    fabricStocks,
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabricId`
    ),
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].baseColorId`
    ),
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].printColorId`
    ),
  ]);

  useEffect(() => {
    updateRow();
  }, [
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].consumption`
    ),
    watch(
      `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].additionalPercentage`
    ),
  ]);

  return (
    <tr>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabric`}
          control={control}
          defaultValue={fabricItem.fabric}
          render={({ field }) => (
            <AntSelect
              allowClear
              placeholder="Select Fabric"
              {...field}
              onChange={name => {
                field.onChange(name);

                setValue(
                  `products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabricId`,
                  null
                );
              }}
            >
              {FabricsForSample.fabricNames.map(name => (
                <Option key={name} value={name}>
                  {name}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].fabricId`}
          control={control}
          defaultValue={fabricItem.fabricId}
          render={({ field }) => (
            <AntSelect allowClear placeholder="Select Width" {...field}>
              {widths.map((width, index) => (
                <Option key={index} value={width.id}>
                  {width.width}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].baseColorId`}
          control={control}
          defaultValue={fabricItem.baseColorId}
          render={({ field }) => (
            <AntSelect allowClear placeholder="Select Color" {...field}>
              {colorIds.map((color, index) => (
                <Option key={index} value={color.id}>
                  {color.color}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].printColorId`}
          control={control}
          defaultValue={fabricItem.printColorId}
          render={({ field }) => (
            <AntSelect allowClear placeholder="Select Color" {...field}>
              {colorIds.map((color, index) => (
                <Option key={index} value={color.id}>
                  {color.color}
                </Option>
              ))}
            </AntSelect>
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].consumption`}
          control={control}
          defaultValue={fabricItem.consumption}
          render={({ field }) => (
            <AntInput
              placeholder="Consumption"
              {...field}
              type="number"
              size="small"
              allowClear={false}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].quantity`}
          control={control}
          defaultValue={fabricItem.quantity}
          render={({ field }) => (
            <AntInput
              placeholder="Quantity"
              {...field}
              type="number"
              size="small"
              disabled
              allowClear={false}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].additionalPercentage`}
          control={control}
          defaultValue={fabricItem.additionalPercentage}
          render={({ field }) => (
            <AntInput
              allowClear={false}
              size="small"
              placeholder="Shrinkage %"
              type="number"
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].totalQuantity`}
          control={control}
          defaultValue={fabricItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="Total Quantity"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].stock`}
          control={control}
          defaultValue={fabricItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="Stock"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <Controller
          name={`products[${productIndex}].styles[${styleIndex}].fabrics[${fabricIndex}].toOrder`}
          control={control}
          defaultValue={fabricItem.totalQuantity}
          render={({ field }) => (
            <AntInput
              size="small"
              placeholder="To Order"
              type="number"
              disabled
              {...field}
            />
          )}
        />
      </td>
      <td className={classes.inputTd}>
        <DeleteOutlined
          onClick={() => {
            const fabrics = getValues(
              `products[${productIndex}].styles[${styleIndex}].fabrics`
            );
            if (fabrics && fabrics.length > 1) {
              fabricsRemove(fabricIndex);
            }
          }}
        />
        &nbsp; &nbsp;
        <PlusCircleOutlined onClick={() => fabricsAppend({})} />
      </td>
    </tr>
  );
};

FabricForm.propTypes = {
  classes: PropTypes.object.isRequired,
  styleIndex: PropTypes.number.isRequired,
  productIndex: PropTypes.number.isRequired,
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  control: PropTypes.any.isRequired,
  fabricItem: PropTypes.object.isRequired,
  fabricIndex: PropTypes.number.isRequired,
  fabricsAppend: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  fabricsRemove: PropTypes.func.isRequired,
  FabricsForSample: PropTypes.object,
};

export default withStyles(styles)(FabricForm);
